import { injectIntl } from "react-intl";

import {
  withBrowser,
  browserShape,
  intlShape,
  formatDate,
  ActionBar,
} from "lcm-iot-commons";
import { getUpdateScheduleStatusIcon } from "../../utils/edgeDeviceUpdateSchedulesUtils";

type Props = {
  updateSchedules: {
    id?: number;
    edge_device?: {
      id?: number;
      href?: string;
    };
    software_version?: {
      id?: number;
      href?: string;
      version_name?: string;
      status?: {
        id?: number;
        href?: string;
      };
      edge_device_type?: {
        id?: number;
        href?: string;
      };
      links?: {
        edge_device_applications?: {
          href?: string;
        };
        software_images?: {
          href?: string;
        };
        edge_device_features?: {
          href?: string;
        };
        edge_device_types?: {
          href?: string;
        };
      };
    };
    status?: {
      id?: number;
      href?: string;
      code?: string;
      name?: string;
    };
  }[];
  browser: browserShape;
  intl: intlShape;
  edgeDevice: {
    id?: number;
    lastSeenAt?: number;
    software_version?: {
      version_name?: string;
    };
  };
};

export function UpdateSchedules({
  intl,
  browser,
  edgeDevice,
  updateSchedules,
}: Props) {
  return (
    <div id="edge-device-update-schedules">
      <ActionBar>
        <h2 id="update-schedules-header">
          {intl.formatMessage({ id: "update_schedules.header" })}
        </h2>
      </ActionBar>
      <table className="update-schedule-table">
        <thead className="update-schedule-table-header">
          <tr>
            <th>
              {intl.formatMessage({ id: "update_schedules.software_version" })}
            </th>
            <th>{intl.formatMessage({ id: "update_schedules.status" })}</th>
            <th>
              {intl.formatMessage({ id: "update_schedules.installed_at" })}
            </th>
          </tr>
        </thead>
        <tbody className="update-schedule-table-body">
          {updateSchedules.map((updateSchedule, index) => (
            <tr
              id={`update-schedules-list-item-${index}`}
              key={`update-schedules-list-item-${(updateSchedule as $TSFixMe)?.updated_at}`}
              className={`${
                updateSchedule?.status?.code === "successful" &&
                edgeDevice?.software_version?.version_name ===
                  updateSchedule?.software_version?.version_name
                  ? "update-schedule-current"
                  : ""
              }`}
              onClick={() =>
                browser.navigateTo(
                  `/edge_devices/${edgeDevice.id}/update_schedules/${updateSchedule.id}`,
                )
              }
            >
              <td id={`update-schedules-list-item-${index}-version_name`}>
                {updateSchedule?.software_version?.version_name}
              </td>
              <td id={`update-schedules-list-item-${index}-status`}>
                <span
                  className={`update-schedules-icon ${getUpdateScheduleStatusIcon(updateSchedule?.status?.code)}`}
                >
                  {updateSchedule?.status?.name}
                </span>
              </td>
              <td id={`update-schedules-list-item-${index}-updated_at`}>
                {(updateSchedule as $TSFixMe)?.updated_at
                  ? formatDate((updateSchedule as $TSFixMe)?.updated_at, intl)
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 2.
export default injectIntl(withBrowser(UpdateSchedules, "EDM::EdgeDevice"));
